// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, EffectFade, Autoplay } from "swiper";
import slide1 from "../../assets/slide/L1180292.jpg";
import slide2 from "../../assets/slide/L1180313.jpg";
import slide3 from "../../assets/slide/L1180211.jpg";
import slide4 from "../../assets/slide/L1180204.jpg";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import "swiper/css/navigation";

export const Slider = () => {
  SwiperCore.use([Autoplay, Navigation]);
  return (
    <>
      <Swiper
        loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        navigation={true}
        modules={[Navigation, EffectFade]}
        effect="fade"
      >
        <SwiperSlide>
          <img src={slide1} alt="" />
          <div className="caption">
            <div className="container">
              <div className="caption__content">
                <h1>
                  I tuoi progetti immobiliari
                  <br />
                  dal progetto alla consegna
                </h1>
                <p>
                  Siamo il punto di riferimento per la gestione completa di
                  tutti gli aspetti di un progetto immobiliare.
                </p>
                <div className="buttons"></div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <img src={slide2} alt="" />
          <div className="caption">
            <div className="container">
              <div className="caption__content">
                <h1>
                  Italimpianti è specializzata nel
                  <br />
                  settore delle costruzioni e, più
                  <br />
                  in particolare, dell'edilizia.
                </h1>
                <p>
                  La nostra azienda è specializzata nella realizzazione di nuove
                  costruzioni di ogni tipo.
                </p>
                <div className="buttons"></div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <img src={slide3} alt="" />
          <div className="caption">
            <div className="container">
              <div className="caption__content">
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <img src={slide4} alt="" />
          <div className="caption">
            <div className="container">
              <div className="caption__content">
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </>
  );
};
